<script setup lang="ts">import { toRef as _toRef } from 'vue';

import { useFavoritesStore } from '@consumer/services/favorites/store'
import { useSharedData } from '@consumer/composables/sharedData'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import FlyOutToast from '../FlyOut/FlyOutToast.vue'
import Favorite from './Favorite.vue'

const favorites = useFavoritesStore()

const __$temp_1 = (useSharedData()),
  currentUser = _toRef(__$temp_1, 'currentUser');
</script>

<template>
  <FlyOutToast
    id="added-to-list-toast"
    :open="Boolean(favorites.lastAddedToList)"
    class="w-100"
    @close="favorites.lastAddedToList = undefined"
  >
    <Favorite
      v-if="favorites.lastAddedToList"
      :favorite="favorites.lastAddedToList.giftListItem"
    >
      <div class="flex flex-col gap-1">
        <span class="flex gap-1.5 items-center">
          <GIcon
            :icon="faCircleCheck"
            color="green-base"
            size="16px"
          />
          <span class="text-nowrap message">
            {{ favorites.lastAddedToList.message }}
          </span>
          <span v-if="currentUser" class="text-grey-400 text-2xl align-middle">
            •
          </span>
          <GPromiseButton
            v-if="currentUser"
            flat
            primary
            size="medium"
            label="Manage lists"
            @click.prevent.stop="
              favorites.openAddToListModal(
                favorites.lastAddedToList.giftListItem,
                { onOpen: () => favorites.lastAddedToList = undefined }
              )
            "
          />
        </span>
      </div>
    </Favorite>
  </FlyOutToast>
</template>
